import React from 'react';
import type { RepositoryPanelData } from 'shiftLeft/api/repository-assets';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

const PlatformRepositoryDetail = withErrorBoundary(
  React.lazy(
    () =>
      import('../../../micro-frontends/components/platform-repository-detail'),
  ),
);

export const PlatformRepositoryDetailView = (props: {
  data: RepositoryPanelData;
}) => {
  return <PlatformRepositoryDetail {...props.data} />;
};
